import './dashboard.scss';
import TopTranslatorsBox from "../topBox/TopBox";
import TranslatorsChat from "../tsChat/tsChat";
import SubtitleUploader from "../subtitleUploader/subtitleUploader";
import {useEffect} from "react";

const TranslatorProfil = () => {

    useEffect(() => {
        const scriptConfig = document.createElement('script');
        scriptConfig.type = 'text/javascript';
        scriptConfig.innerHTML = `
            atOptions = {
                'key' : 'a3d1bf1abb78f156c98ce7aac0b21f43',
                'format' : 'iframe',
                'height' : 300,
                'width' : 160,
                'params' : {}
            };
        `;

        const scriptTag = document.createElement('script');
        scriptTag.type = 'text/javascript';
        scriptTag.src = '//www.highperformanceformat.com/a3d1bf1abb78f156c98ce7aac0b21f43/invoke.js';

        const adContainer = document.getElementById('adsterra-banner');
        if (adContainer) {
            adContainer.appendChild(scriptConfig);
            adContainer.appendChild(scriptTag);
        }

        // Optional: Clean up when component unmounts
        return () => {
            if (adContainer) adContainer.innerHTML = '';
        };
    }, []);

    return (
        <div className="home">
            <div className="box box1">
                <TopTranslatorsBox/>
            </div>
            <div className="box box2">
                <TranslatorsChat/>
            </div>
            <div className="box box2">
                <SubtitleUploader/>
            </div>
            <div id="adsterra-banner" className="box box3" />
        </div>
    );
};

export default TranslatorProfil;
